<template>
  <div>
    <div class="flex flex-wrap items-center justify-between gap-3 mb-3">
      <h4 class="text-sm font-semibold">Ceremony analysis</h4>
      <div class="flex flex-wrap items-center gap-2 min-w-0 max-w-full">
        <label class="text-xs text-gray-600">View</label>
        <select v-model="surveyCeremonyViewModeProxy" class="border rounded px-2 py-1 text-xs">
          <option value="table">Table</option>
          <option value="chart">Chart</option>
        </select>
        <label class="text-xs text-gray-600 ml-2">Sort</label>
        <select v-model="surveyCeremonySortModeProxy" class="border rounded px-2 py-1 text-xs">
          <option value="date_asc">Date (oldest first)</option>
          <option value="date_desc">Date (newest first)</option>
          <option value="response_rate_desc">Performance: Response rate</option>
          <option value="responders_desc">Performance: Responders</option>
          <option value="registrations_desc">Performance: Registrations</option>
        </select>
        <template v-if="state.surveyCeremonyViewMode === 'chart'">
          <label class="text-xs text-gray-600 ml-2">Metric</label>
          <select v-model="surveyCeremonyChartMetricProxy" class="border rounded px-2 py-1 text-xs">
            <option value="response_rate_pct">Response rate %</option>
            <option value="responders">Responders</option>
            <option value="total_registrations">Registrations</option>
          </select>
        </template>
      </div>
    </div>

    <div v-if="!state.surveyCeremonyRowsSorted.length" class="text-sm text-gray-500 mb-4">No ceremony-level survey data in scope.</div>
    <div v-else-if="state.surveyCeremonyViewMode === 'table'" class="overflow-x-auto border rounded-lg bg-white mb-5">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 text-gray-600">
          <tr>
            <th class="text-left px-3 py-2">Ceremony</th>
            <th class="text-right px-3 py-2">Registrations</th>
            <th class="text-right px-3 py-2">Responders</th>
            <th class="text-right px-3 py-2">Response rate</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in state.surveyCeremonyRowsSorted" :key="`survey-${row.ceremony_id}`" class="border-t">
            <td class="px-3 py-2">
              <div class="font-medium">{{ actions.ceremonyTitle(row) }}</div>
              <div class="text-xs text-gray-500">{{ row.ceremony_id }}</div>
            </td>
            <td class="px-3 py-2 text-right">{{ row.total_registrations }}</td>
            <td class="px-3 py-2 text-right">{{ row.responders }}</td>
            <td class="px-3 py-2 text-right font-medium">{{ row.response_rate_pct }}%</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="border rounded-lg bg-white p-4 mb-5">
      <div class="text-xs text-gray-600 mb-3">Visual comparison by ceremony ({{ state.surveyChartMetricLabel }})</div>
      <div class="space-y-2 max-h-[320px] overflow-auto pr-1">
        <div v-for="row in state.surveyCeremonyRowsSorted" :key="`survey-chart-${row.ceremony_id}`">
          <div class="flex justify-between text-xs mb-1">
            <span class="truncate max-w-[70%]" :title="actions.ceremonyTitle(row)">{{ actions.ceremonyTitle(row) }}</span>
            <span>{{ actions.surveyMetricValue(row, state.surveyCeremonyChartMetric) }}<template v-if="state.surveyCeremonyChartMetric === 'response_rate_pct'">%</template></span>
          </div>
          <div class="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
            <div class="h-2 rounded-full bg-gradient-to-r from-black to-gray-600" :style="{ width: actions.surveyMetricWidth(row, state.surveyCeremonyChartMetric) }"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyCeremonySection',
  props: {
    state: { type: Object, required: true },
    actions: { type: Object, required: true },
  },
  computed: {
    surveyCeremonyViewModeProxy: {
      get() { return this.state.surveyCeremonyViewMode },
      set(value) { this.$emit('update:surveyCeremonyViewMode', value) },
    },
    surveyCeremonySortModeProxy: {
      get() { return this.state.surveyCeremonySortMode },
      set(value) { this.$emit('update:surveyCeremonySortMode', value) },
    },
    surveyCeremonyChartMetricProxy: {
      get() { return this.state.surveyCeremonyChartMetric },
      set(value) { this.$emit('update:surveyCeremonyChartMetric', value) },
    },
  },
}
</script>
